import { Check } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import PriceTable from "@/components/PriceTable";
import CTASection from "@/components/CTASection";
import ZWImage from "@/components/ZWImage";
import { AUSZUG_UMFANG, AUSZUG_ROWS, AUSZUG_EXTRA, HINWEISE } from "@/data/services";

export default function Auszugsreinigung() {
  return (
    <>
      <SEO
        title="Auszugs- & Übergabereinigung Herten – Festpreise nach Wohnungsgröße | ZWILLINGSWERK"
        description="Auszugsreinigung in Herten + 20 km zum Festpreis: 1-Zimmer ab 149 €, 3-Zimmer ab 279 €, Einfamilienhaus ab 499 €. Besenrein, termingerecht, mit Endkontrolle zur Übergabe."
      />
      <PageHero
        eyebrow="Auszugs- & Übergabereinigung · Festpreis"
        title="Sauber. Schnell. Stressfrei."
        description="Sie ziehen aus? Wir übernehmen die komplette Reinigung Ihrer Wohnung oder Ihres Hauses – gründlich, zuverlässig und termingerecht. So übergeben Sie Ihre Immobilie in bestem Zustand – ganz ohne Stress."
        testid="auszug-hero"
      />

      <section className="py-14 bg-[#F8FAF8] border-b border-[#D7E5D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8 space-y-8">
              <PriceTable
                title="Preise nach Wohnungsgröße"
                subtitle="Komplette Wohnungsreinigung – bezugsfertig & übergabebereit"
                badge="Festpreis"
                rows={AUSZUG_ROWS}
                footnote="Inklusive Endkontrolle für die Wohnungsübergabe. Anfahrt 20 km inklusive."
                testid="price-table-auszug"
              />

              <div className="bg-white rounded-xl border border-[#D7E5D9] p-6" data-testid="auszug-umfang">
                <h2 className="text-xl font-black text-[#122B18] font-display mb-4">
                  Leistungsumfang der kompletten Wohnungsreinigung
                </h2>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 text-sm text-[#3A523E]">
                  {AUSZUG_UMFANG.map((u) => (
                    <li key={u} className="flex items-start gap-2">
                      <Check className="w-4 h-4 text-[#1E5631] shrink-0 mt-0.5" /> {u}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <aside className="lg:col-span-4 space-y-6">
              <ZWImage
                src="/images/auszug.png"
                fallback="https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Strahlend saubere, leere Wohnung nach der Auszugsreinigung durch ZWILLINGSWERK"
                className="w-full aspect-[4/3] rounded-2xl shadow-lg"
                subcaption="Übergabereinigung"
                caption="Besenrein & ohne Diskussion"
                testid="auszug-image"
              />

              <div className="bg-white border border-[#D7E5D9] rounded-2xl p-6 space-y-3" data-testid="auszug-extras">
                <h2 className="text-sm font-bold text-[#122B18] uppercase tracking-wider">Zusatzleistungen</h2>
                <ul className="divide-y divide-[#E6EFE7] text-sm">
                  {AUSZUG_EXTRA.map((e) => (
                    <li key={e.name} className="flex justify-between gap-3 py-2">
                      <span className="text-[#1B281B]">{e.name}</span>
                      <span className="font-bold text-[#1E5631] whitespace-nowrap">{e.price}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-white border border-[#D7E5D9] rounded-2xl p-6 space-y-3 text-xs text-[#4A634E]">
                <h2 className="text-sm font-bold text-[#122B18] uppercase tracking-wider">Wichtige Hinweise</h2>
                <p>{HINWEISE.mindest}</p>
                <p>{HINWEISE.anfahrt}</p>
                <p>{HINWEISE.zahlung}</p>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
